window.dn = window.dn || {};

/** All methods related to message types */
(function (type, $, undefined)
{
    /** 
     * Used in response to the Update(), Subscribe(), and Invite() methods to reflect what happened. 
     *  
     * Keep this in sync with C# Type.TypeAction enum.
    */
    type.TypeAction = 
    {
        None:       0,
        Completed:  1,
        Created:    2,
        Failed:     3,
        Updated:    4,
        Queued:     5
    };

    /**
     * The DOM identifier used for the modal dialogs, and prefix for related elements.
     */
    type.CreateTypeId = "dn-create-type";

    /**
     * Add a manager to a type.
     * 
     * @param {string}  opt.typeIdOrKey             - The TypeId or TypeKey of the type being modified.
     * @param {string}  opt.canEditMessage          - Whether this manager can edit messages of this type.
     * @param {string}  opt.canEditMessageStatus    - Whether this manager can edit message statuses of this type.
     * @param {string}  opt.canEditMessageType      - Whether this manager can edit message types of this type.
     * @param {string}  opt.notify                  - Whether this manager will receive notifications of this type.
     * @param {string}  opt.userKey                 - The UserKey of the user to make a manager of this type.
     * @param {func}    opt.onSuccess               - If we're able to successfully add the manager, we'll call this with the response.
     * @param {func}    opt.onError                 - If we can't invite/approve the user for some reason, we'll call this with the jquery error info
     */
    type.AddManager = function(opt) 
    {
        $.postJSON("/api/v1/type/" + opt.typeIdOrKey + "/manager", 
        {
            CanEditMessage: opt.canEditMessage,
            CanEditMessageStatus: opt.canEditMessageStatus,
            CanEditMessageType: opt.canEditMessageType,
            Notify: opt.notify,
            UserKey: opt.userKey
        })
        .done(function (response) 
        {
            if (opt.onSuccess)
            {
                opt.onSuccess(response);
            }
        })
        .fail(function (xhr, textStatus, errorThrown) 
        {
            if (opt.onError)
            {
                opt.onError(xhr, textStatus, errorThrown);
            }
        });
    };

    /**
     * This gets wired up to checkboxes to handle type subscriptions.
     * The element should contain data-type-id="" or data-type-key=""
     * 
     * @param {event}   event   - The target of the event. Probably a checkbox.
     */
    type.HandleSubscribeClick = function(event)
    {
        var $targetLabel = $(event.currentTarget);
        var $currentLabel = $targetLabel.parents(".btn-subscribe-type").find("label.active");

        event.stopPropagation(); // allow the toggle function to work, but only register one click

        if (!dn.user.IsLoggedIn)
        {
            // Anon users get asked to login first
            dn.PromptToLogin('subscribe to a type');
            return;
        }

        var $targetInput = $targetLabel.find('input[data-type-id]');

        var typeId = $targetInput.data('type-id');
        var subscription = $targetInput.data('subscription');
        var type = dn.constants.DiscussionTypes[typeId]

        console.debug("type.HandleSubscribeClick", event, type, subscription, $currentLabel);

        // can match multiple buttons on the same page, so the status of all of them can be updated at once
        // For example, on type pages, the button appears on the right side, as well as in the dropdown menu.
        var $buttons = $('.btn-subscribe-type input[data-type-id=' + typeId + ']');

        // disable the buttons while we handle this change
        $buttons.attr('disabled', true).parent().attr('disabled', true);

        // Clear state on all buttons (checked, active).
        $buttons.not($targetInput).attr('checked', false).parent().not($targetLabel).removeClass("active");

        // Mark the new ones, we'll assume this will work
        $targetLabel.addClass("active");
        $targetInput.attr('checked', true);

        dn.type.Subscribe
        (
            {
                typeIdOrKey: typeId, 
                subscription: subscription,
                userKey: dn.QueryString.userkey,

                onSuccess: function(response) 
                {
                    // Clear disabled on all buttons
                    $buttons.attr('disabled', false).parent().attr('disabled', false);
                }, 

                onError: function(xhr, textStatus, errorThrown) 
                {
                    // Set the button to it's original state

                    // Clear state on all buttons, including disabled, checked, active. Then hone in
                    // on the one related to our current status, and set it to checked/active.
                    $buttons.attr('disabled', false).attr('checked', false).parent().attr('disabled', false).removeClass("active");
                    $currentLabel.addClass("active");
                    $currentLabel.find("input").attr('checked', true);

                    if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                    {
                        dn.ShowModal({
                            title: 'Problem Changing Subscription',
                            body: dn.FormatApiError(xhr.responseJSON) + '<br/><br/>If you have any questions, please <a href="/contact">contact us</a>.'
                        });
                    }
                }
            }
        );
    };

    /**
     * @param {string}  opt.typeIdOrKey     - The TypeId or TypeKey to look up
     * @param {bool}    opt.showAjaxSpinner - If true, we'll show a modal spinner if we have to make an ajax call (and hide it when done)
     * @param {func}    opt.onSuccess       - Once we have the Type available, we send it to this callback.
     * @param {func}    opt.onError         - If we can't locate this type's details for some reason, we'll call this callback.
     */
    type.Lookup = function(opt) 
    {
        if (!opt.typeIdOrKey) { return opt.onSuccess({}); } // nothing to lookup

        // we currently cache all types on-client, so no ajax needed
        opt.onSuccess(dn.constants.DiscussionTypes[opt.typeIdOrKey]);
    };

    /**
     * Get type autosuggestions by passing a query string of a partial (or whole) type name.
     * 
     * @param {string}      opt.query       - A whole or partial type name. If null or empty, all types will be returned.
     * @param {bool}        opt.isManager   - If true, only return types that this user is a manager of.
     * @param {function}    opt.onSuccess   - On success, we'll call this function with the returned data.
     * @param {function}    opt.onError     - On failure, we'll call this function with the error message.
     */
    type.Query = function (opt) 
    {
        $.postJSON
        (
            "/api/v1/type/query", 
            {
                Query: opt.query,
                IsManager: opt.isManager
            }
        )
        .done(function (data, textStatus, request) 
        {
            if (opt.onSuccess)
            {
                opt.onSuccess(data);
            }
        })
        .fail(function (xhr, textStatus, errorThrown) 
        {
            if (opt.onError)
            {
                opt.onError(errorThrown);
            }
        });
    };

    /**
     * Remove a manager from a type.
     * 
     * @param {string}  opt.typeIdOrKey - The TypeId or TypeKey of the type being modified.
     * @param {string}  opt.notify      - Whether this manager will receive notifications of this type.
     * @param {string}  opt.userKey     - The UserKey of the user to remove as a manager of this type.
     * @param {func}    opt.onSuccess   - If we're able to successfully add the manager, we'll call this with the response.
     * @param {func}    opt.onError     - If we can't invite/approve the user for some reason, we'll call this with the jquery error info
     */
    type.RemoveManager = function(opt) 
    {
        $.deleteJSON("/api/v1/type/" + opt.typeIdOrKey + "/manager", 
        {
            UserKey: opt.userKey,
            Notify: opt.notify
        })
        .done(function (response) 
        {
            if (opt.onSuccess)
            {
                opt.onSuccess(response);
            }
        })
        .fail(function (xhr, textStatus, errorThrown) {

            if (opt.onError)
            {
                opt.onError(xhr, textStatus, errorThrown);
            }
        });
    };

    /**
     * Attempt to subscribe the user to a message a type, and then show them the results.
     * 
     * @param {string}  opt.typeIdOrKey - The TypeId or TypeKey to subscribe to.
     * @param {number}  opt.subscription    - The type of subscription: -1 (Never) or +1 (Always). If you pass 0 then this works like Unsubscribe.
     * @param {string}  opt.userKey     - (Optional) If a manager is calling this on behalf of another user subscribed to their 
     *                                    type (i.e. to remove them), pass the user's UserKey.
     * @param {func}    opt.onSuccess   - If we're able to successfully subscribe (or queue subscription), we'll call this with the response.
     * @param {func}    opt.onError     - If we can't subscribe the user for some reason, we'll call this with the jquery error info
     */
    type.Subscribe = function(opt) 
    {
        $.postJSON("/api/v1/type/" + opt.typeIdOrKey + "/subscription", 
        {
            Subscription: opt.subscription,
            UserKey: opt.userKey
        })
        .done(function (response) 
        {
            if (response.Action === type.TypeAction.Completed)
            {
                // Add the TypeId to the dn.user.TypeSubscriptions array
                if ($.isArray(dn.user.TypeSubscriptions))
                {
                    dn.user.TypeSubscriptions.push(response.Type.TypeId);
                }
                else
                {
                    dn.user.TypeSubscriptions = [response.Type.TypeId];
                }
            }

            if (opt.onSuccess)
            {
                opt.onSuccess(response);
            }
        })
        .fail(function (xhr, textStatus, errorThrown) {

            if (opt.onError)
            {
                opt.onError(xhr, textStatus, errorThrown);
            }
        });
    };

    /**
     * Attempt to unsubscribe the user from a message type, and then show them the results.
     * 
     * @param {string}  opt.typeIdOrKey - The TypeId or TypeKey to unsubscribe from.
     * @param {string}  opt.userKey     - (Optional) If a manager is calling this on behalf of another user subscribed to their 
     *                                    type (i.e. to remove them), pass the user's UserKey.
     * @param {func}    opt.onSuccess   - If we're able to successfully subscribe (or queue subscription), we'll call this with the response.
     * @param {func}    opt.onError     - If we can't subscribe the user for some reason, we'll call this with the jquery error info
     */
    type.Unsubscribe = function(opt) 
    {
        $.deleteJSON("/api/v1/type/" + opt.typeIdOrKey + "/subscription", 
        {
            UserKey: opt.userKey
        })
        .done(function (response) 
        {
            if ($.isArray(dn.user.TypeSubscriptions))
            {
                // Remove the TypeId from the dn.user.TypeSubscriptions array
                dn.user.TypeSubscriptions = dn.user.TypeSubscriptions.filter(function(typeId) 
                {
                    return (typeId !== response.Type.TypeId);
                });
            }

            if ($.isArray(dn.user.TopicSubscriptionsPending))
            {
                // Remove the TypeId from the dn.user.TopicSubscriptionsPending array, if it's there
                dn.user.TopicSubscriptionsPending = dn.user.TopicSubscriptionsPending.filter(function(typeId) {
                    return (typeId !== response.Type.TypeId);
                });
            }

            if (opt.onSuccess)
            {
                opt.onSuccess(response);
            }
        })
        .fail(function (xhr, textStatus, errorThrown) 
        {
            if (opt.onError)
            {
                opt.onError(xhr, textStatus, errorThrown);
            }
        });
    };

    /**
     * Update a manager of a type.
     * 
     * @param {string}  opt.typeIdOrKey             - The TypeId or TypeKey of the type being modified.
     * @param {string}  opt.canEditMessage          - Whether this manager can edit messages of this type.
     * @param {string}  opt.canEditMessageStatus    - Whether this manager can edit message statuses of this type.
     * @param {string}  opt.canEditMessageType      - Whether this manager can edit message types of this type.
     * @param {string}  opt.notify                  - Whether this manager will receive notifications of this type.
     * @param {string}  opt.userKey                 - The UserKey of the user to make a manager of this type.
     * @param {func}    opt.onSuccess               - If we're able to successfully add the manager, we'll call this with the response.
     * @param {func}    opt.onError                 - If we can't invite/approve the user for some reason, we'll call this with the jquery error info
     */
    type.UpdateManager = function(opt) 
    {
        $.patchJSON("/api/v1/type/" + opt.typeIdOrKey + "/manager", 
        {
            CanEditMessage: opt.canEditMessage,
            CanEditMessageStatus: opt.canEditMessageStatus,
            CanEditMessageType: opt.canEditMessageType,
            Notify: opt.notify,
            UserKey: opt.userKey
        })
        .done(function (response) 
        {
            if (opt.onSuccess)
            {
                opt.onSuccess(response);
            }
        })
        .fail(function (xhr, textStatus, errorThrown) 
        {
            if (opt.onError)
            {
                opt.onError(xhr, textStatus, errorThrown);
            }
        });
    };

    $(document).ready(function ($)
    {
        // Wire up any subscription buttons on the page to our handler for subscribe/unsubscribe.
        $('.btn-subscribe-type label').click(dn.type.HandleSubscribeClick);
    });

}(window.dn.type = window.dn.type || {}, jQuery));
